import { useEffect } from "react";
import { LanderConfigAction, useLanderConfig } from "../commons/ConfigContext";
import { System } from "../commons/Constants";
import { ExperimentIds } from "../commons/constants/experiment";
import { isControlCohort } from "./helper";

export const BACKFILL_V2_CONTROL_TAG = "PW_YAHOO_BACKFILL_V2_CONTROL";
export const BACKFILL_V2_TREATMENT_TAG = "PW_YAHOO_BACKFILL_V2_TREATMENT";

export function useYahooBackfillExperiment() {
  const { landerConfig, landerConfigDispatch } = useLanderConfig();
  const { experiment: { key, cohort } = {} } = landerConfig;

  const inExperiment = key === ExperimentIds.yahooBackfillRollerAdsV2;
  const inTreatmentCohort =
    inExperiment && !!cohort && !isControlCohort(cohort);
  const isParkWeb = landerConfig.system === System.PARKWEB;
  const isEligible = inExperiment && isParkWeb;

  const isBackfillEligible = isEligible && inTreatmentCohort;

  useEffect(() => {
    if (!isEligible) return;

    landerConfigDispatch({
      type: LanderConfigAction.UPDATE_YAHOO_TYPE_TAG,
      payload: {
        typeTag: inTreatmentCohort
          ? BACKFILL_V2_TREATMENT_TAG
          : BACKFILL_V2_CONTROL_TAG,
      },
    });
  }, [isEligible, inTreatmentCohort, landerConfigDispatch]);

  return { isBackfillEligible };
}
